import { ACTION_TYPES } from '../../constants/protocol';
import { formatTime } from '../helpers';

/**
 * Fields merged into the body for the global master control (POST
 * /switches/master-control or /blowers/master-control, `actionType:
 * GLOBAL_MASTER_CONTROL`), built from the `selectedMachines` slice.
 * Temperatures in the draft are already °C.
 *
 * @param {Object} selectedMachines  `state.selectedMachines`
 * @param {number} commandNumber  from GET /audits/command-number
 * @returns {Object<string, *>}
 */
export const globalMasterControlPayload = (selectedMachines, commandNumber) => {
  const {
    instantHeat,
    optionalConstantTemp,
    snowSensor,
    windFactor,
    heatingSchedule,
    heatingScheduleList,
    isFanOnly,
    atsState,
    mCOff,
  } = selectedMachines;
  const schedule = heatingScheduleList[0];
  const ebp = atsState.selections.indexOf(true);

  return {
    commandNumber,
    actionType: ACTION_TYPES.GLOBAL_MASTER_CONTROL,
    ...(instantHeat.ready && {
      instant_temp: instantHeat.temp,
      on_switch: 1,
    }),
    ...(mCOff.instantHeat === true && { on_switch: 0 }),
    ...(optionalConstantTemp.ready && {
      constant_temp: optionalConstantTemp.temp,
      on_constant: 1,
    }),
    ...(mCOff.optionalConstantTemp === true && { on_constant: 0 }),
    ...(snowSensor.ready && { snow_enabled: 1 }),
    ...(mCOff.snowSensor === true && { snow_enabled: 0 }),
    ...(windFactor.ready && { wind: 1 }),
    ...(mCOff.windFactor === true && { wind: 0 }),
    ...(heatingSchedule.ready && {
      schedule: {
        startDate: formatTime(schedule.start),
        endDate: formatTime(schedule.end),
        threshold: schedule.inputTemp,
      },
    }),
    ...(mCOff.heatingSchedule === true && { deleteCurrentSchedule: true }),
    ...(isFanOnly && { fan: 1 }),
    ...(mCOff.isFanOnly === true && { fan: 0 }),
    ...(ebp !== -1 && { EBP: ebp }),
  };
};
